import Routes from "./componentes/Routes";
import { useTheme } from "./configurations/themeProvider";
import "./configurations/colors.scss";
import "./styles/App.scss";

const App = () => {
    const { theme, isReady } = useTheme();

    if (!isReady) {
        return null;
    }

    return (
        <div className="App" data-theme={theme}>
            <Routes />
        </div>
    );
};

export default App;